export const PoemDistance = () => {
    return (
        <div id="034" className="">
            <p>bird silhouettes up above,</p>
            <p>and their shadows disperse before hitting the ground,</p>
            <p>the distance does always feel safest.</p>
            <br />
            <p>the sky sometimes looks like a friend, doesn't it?</p>
            <p>in the space between one and the rest of the world,</p>
            <p>there's always a small risk of becoming a stranger.</p>
            <br />
            <p>either high in the air or deep underground, if only</p>
            <p>anything grew where there's nothing else</p>
            <p>to challenge the space,</p>
            <p>it's easiest to find the edge of the world,</p>
            <p>it's easiest to starve, isn't it?</p>
        </div>
    );
};
